import { memo } from "react";
import { Card, CardContent, IconButton, Stack, Typography } from "@mui/material";
import Accordion from "@services/components/Accordion";

interface WesentlichkeitsIROCardProps {
    title: string;
}

const WesentlichkeitsIROCard = memo(({ title }: WesentlichkeitsIROCardProps) => {
    return (
        <Card sx={{ p: 1.5 }}>
            <CardContent>
                <Typography variant={"h6"} fontSize={"1.2rem"}>
                    {title}
                </Typography>
            </CardContent>

            <CardContent>
                <Accordion title={"Wasserentnahme"} sx={{ background: "transparent" }} hideExpandIcon isHeader>
                    <Stack direction={"row"} alignItems={"center"} spacing={2.75} px={1.75}>
                        <IconButton size={"medium"}>
                            <Typography fontWeight={600}>I</Typography>
                        </IconButton>
                        <IconButton size={"medium"}>
                            <Typography fontWeight={600}>R</Typography>
                        </IconButton>
                        <IconButton size={"medium"}>
                            <Typography fontWeight={600}>O</Typography>
                        </IconButton>
                    </Stack>
                </Accordion>

                <Accordion title={"Wasserentnahme"} details={"woiurvn"}>
                    <Stack direction={"row"} alignItems={"center"} spacing={3} px={2}>
                        <IconButton size={"medium"}>
                            <Typography>3</Typography>
                        </IconButton>
                        <IconButton size={"medium"}>
                            <Typography>3</Typography>
                        </IconButton>
                        <IconButton size={"medium"}>
                            <Typography>3</Typography>
                        </IconButton>
                    </Stack>
                </Accordion>

                <Accordion title={"Wasserverbrauch"} details={"woiurvn"}>
                    <Stack direction={"row"} alignItems={"center"} spacing={3} px={2}>
                        <IconButton size={"medium"}>
                            <Typography>3</Typography>
                        </IconButton>
                        <IconButton size={"medium"}>
                            <Typography>3</Typography>
                        </IconButton>
                        <IconButton size={"medium"}>
                            <Typography>3</Typography>
                        </IconButton>
                    </Stack>
                </Accordion>

                <Accordion title={"Ableitung von Wasser"} details={"woiurvn"}>
                    <Stack direction={"row"} alignItems={"center"} spacing={3} px={2}>
                        <IconButton size={"medium"}>
                            <Typography>3</Typography>
                        </IconButton>
                        <IconButton size={"medium"}>
                            <Typography>3</Typography>
                        </IconButton>
                        <IconButton size={"medium"}>
                            <Typography>3</Typography>
                        </IconButton>
                    </Stack>
                </Accordion>

                <Accordion title={"Ableitung von Wasser in die Oceane"} details={"woiurvn"}>
                    <Stack direction={"row"} alignItems={"center"} spacing={3} px={2}>
                        <IconButton size={"medium"}>
                            <Typography>3</Typography>
                        </IconButton>
                        <IconButton size={"medium"}>
                            <Typography>3</Typography>
                        </IconButton>
                        <IconButton size={"medium"}>
                            <Typography>3</Typography>
                        </IconButton>
                    </Stack>
                </Accordion>

                <Accordion title={"Gewinnung und Nutzung von Meeresressoucen"} details={"woiurvn"}>
                    <Stack direction={"row"} alignItems={"center"} spacing={3} px={2}>
                        <IconButton size={"medium"}>
                            <Typography>3</Typography>
                        </IconButton>
                        <IconButton size={"medium"}>
                            <Typography>3</Typography>
                        </IconButton>
                        <IconButton size={"medium"}>
                            <Typography>3</Typography>
                        </IconButton>
                    </Stack>
                </Accordion>
            </CardContent>
        </Card>
    );
});

export default WesentlichkeitsIROCard;
